import {ICategory, ICategoryListItem} from '../types/category';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {IFilterConfigDTO} from '../types/galleryTypes';
import {RouterPrefix} from '@wix/wixstores-client-core';

export class CategoriesService {
  public visibleCategories: ICategoryListItem[];
  private categoryListConfig: IFilterConfigDTO;

  constructor(
    private readonly allCategories: ICategoryListItem[],
    private readonly siteStore: SiteStore,
    private readonly allProductsCategoryId: string
  ) {}

  public updateVisibleCategories({
    categoryListConfig,
    shouldUseCategoryListConfig,
  }: {
    categoryListConfig?: IFilterConfigDTO;
    shouldUseCategoryListConfig: boolean;
  }) {
    if (categoryListConfig) {
      this.categoryListConfig = categoryListConfig;
    }

    let categories = [...this.allCategories];
    if (shouldUseCategoryListConfig && this.categoryListConfig !== undefined) {
      const sortedIds = [];
      const selectedCategoriesFromConfig = this.categoryListConfig.selected.reduce((obj, item) => {
        obj[item.id] = null;
        sortedIds.push(item.id);
        return obj;
      }, {});

      categories = categories
        .filter((c) => c.visible && c.id in selectedCategoriesFromConfig)
        .sort((a, b) => sortedIds.indexOf(a.id) - sortedIds.indexOf(b.id));
    } else {
      categories = categories.filter((c) => c.visible).sort((a, b) => a.name.localeCompare(b.name));
      const defaultCategoryIndex = categories.findIndex((c) => c.id === this.allProductsCategoryId);
      if (defaultCategoryIndex !== -1) {
        categories.unshift(categories.splice(defaultCategoryIndex, 1)[0]);
      }
    }

    this.visibleCategories = categories.map((c) => {
      return {
        ...c,
        categoryUrl: `${this.siteStore.location.baseUrl}/${RouterPrefix.CATEGORY}/${c.slug}`,
      };
    });
  }

  public getCategoryBySlug(slug?: string): ICategory {
    return (this.allCategories.find((c) => c.slug === slug) as ICategory) ?? (this.visibleCategories[0] as ICategory);
  }
}
